<div *ngIf="currentUrl !== '/log-in'" class="d-flex" id="panel-layout">


  <!-- Sidebar -->
  <nav style="padding-top: 0px !important;" [class.collapsed]="isCollapsed"
    class="sidebar bg-dark text-white p-3 panel-sidebar">
    <div class="sidebar-header d-flex justify-content-between align-items-center">



      <button *ngIf="!isCollapsed" class="btn btn-dark btn-sm toggle-btn" (click)="toggleSidebar()"
        aria-label="Toggle Sidebar">



        <i class="collapsed" [class]="isCollapsed ? 'fas fa-chevron-right' : 'fas fa-chevron-left'"></i>
      </button>

      <button *ngIf="isCollapsed" class="btn btn-sm collapse_button" (click)="toggleSidebar()"
        aria-label="Toggle Sidebar">


        <i class="collapsed" [class]="isCollapsed ? 'fas fa-chevron-right' : 'fas fa-chevron-left'"></i>
      </button>

      <img routerLink="/panel/dashboard" class="img-logo" *ngIf="!isCollapsed" width="70px" src="assets/img/logo_principal.svg" alt="Logo">
      <img routerLink="/panel/dashboard" class="img-logo img-logo-collapsed" *ngIf="isCollapsed" width="35px" src="assets/img/logo_small.png"
        alt="Logo">

    </div>

    <div class="divider"></div>

    <div  [class]="isCollapsed ? 'collapsed_user' : ''" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" routerLink="/panel/profile"
      class="dropdown panel-menu-user" style="position: relative; display: inline-block;">

      <!-- Imagen que activa el menú -->
      <img src="{{data.imageUrl}}" class="rounded-circle panel_user_img" (click)="toggleDropdown()" />
      <span *ngIf="!isCollapsed" style="margin-left: 10px;">
        <label class="pointer">{{data.names | truncate:15}}</label>

      </span>


    </div>
    <div class="divider"></div>





    <ul class="nav flex-column">

      <li class="nav-item">
        <a routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" *ngIf="!isCollapsed"
          class="nav-link text-white" routerLink="/panel/dashboard">
          <i class="fas fa-chart-pie"></i>Dashboard
        </a>
        <a routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" *ngIf="isCollapsed"
          class="nav-link text-white collapsed" routerLink="/panel/dashboard">
          <i class="fas fa-chart-pie"></i>
        </a>
      </li>
      <li class="nav-item">
        <a routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" *ngIf="!isCollapsed"
          class="nav-link text-white" routerLink="/panel/services">
          <i class="fas fa-server"></i> Mis Servicios
        </a>
        <a routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" *ngIf="isCollapsed"
        class="nav-link text-white collapsed" routerLink="/panel/services">
        <i class="fas fa-server"></i>
      </a>
      </li>
      <li class="nav-item">
        <a routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" *ngIf="!isCollapsed"
          class="nav-link text-white" routerLink="/panel/payment-methods">
          <i class="fas fa-credit-card"></i> Métodos de Pago
        </a>
        <a routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" *ngIf="isCollapsed"
        class="nav-link text-white collapsed" routerLink="/panel/payment-methods">
        <i class="fas fa-credit-card"></i>
      </a>
      </li>


      <li class="nav-item last-option ">
        <a *ngIf="!isCollapsed" class="nav-link text-white" routerLink="/">
          <i class="fas fa-arrow-circle-left"></i> enCloud
        </a>
        <a *ngIf="isCollapsed" class="nav-link text-white collapsed menu-adjustment" routerLink="/">
          <i class="fas fa-arrow-circle-left"></i>
        </a>
      </li>
    </ul>
  </nav>

  <!-- Main Content -->
  <div class="content flex-grow-1 p-4" [ngClass]="{'collapsed': isCollapsed}">
    <router-outlet></router-outlet>
  </div>
</div>


